import React, { useLayoutEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'

import { startHostReservedResults } from '../firebase/venues'
import { makeHostReservationsUrl } from '../components/helpers'
import { getIsFetching, setIsFetching, setSearchResults } from '../store/search'
import { getUser } from '../store/user'

import RequireUser from '../components/RequireUser'
import SearchVenues from '../components/SearchVenues'
import Loading from '../components/Loading'

const PageHostReservations = () => {
  const dispatch = useDispatch()
  const isFetching = useSelector(getIsFetching)
  const user = useSelector(getUser)

  useLayoutEffect(() => {
    startHostReservedResults({
      setFetching(value) {
        dispatch(setIsFetching(value))
      },
      setSearchResults(results) {
        dispatch(setSearchResults(results))
      },
      user,
    })
  }, [])

  if (isFetching) {
    return <Loading />
  }

  return (
    <SearchVenues
      disableMapView
      disableBookButton
      defaultTitle="Hosted Reservations"
      countTitle="reservation"
      noResultsMessage='No hosted reservations found'
      makeUrl={makeHostReservationsUrl}
    />
  )
}

export default () => (
  <RequireUser>
    <PageHostReservations />
  </RequireUser>
)
